/**
 * Audio configuration constants
 * These values match the backend WAV configuration for consistency
 */

/**
 * Default sample rate for streaming PCM audio (matches backend STREAMING_WAV_SAMPLE_RATE)
 */
export const STREAMING_AUDIO_SAMPLE_RATE = 24000;

/**
 * Default number of audio channels (mono)
 */
export const DEFAULT_AUDIO_CHANNELS = 1;
